import React from 'react';
import { Tooltip } from '@material-ui/core';
import { TRACKING } from 'common/constants/constants';
import { SPACES } from 'common/constants/sizes';
import * as TrackingService from 'common/services/tracking.service';
import { HyperLink } from 'components/base/HyperLink';
import Icon from 'components/base/Icon';
import { Flex, Padding } from 'components/base/layout-components';
import Text from 'components/base/Text';
import AppRouter from 'common/AppRouter';

const TeamNotificationListHeaders = ({ applicationName, history }) => (
  <>
    <Text
      size='large'
      color='abbey'
      weight='500'
      pb={SPACES.small}
      textTransform='uppercase'
    >
      {applicationName} notifications
    </Text>
    <Flex direction='row' items='flex-end' pb='medium'>
      <Text size='large' color='shuttleGray' pr={SPACES.small}>
        Select which notifications to receive on {applicationName}.
      </Text>
      <Flex>
        <Tooltip
          placement='top'
          title={
            <Flex direction='row' items='center'>
              <Flex>
                <Icon name='pencil' color='shuttleGray' size='x-small' />
              </Flex>
              <Padding l='x-small'>
                Edit thresholds for each notification
              </Padding>
            </Flex>
          }
        >
          <HyperLink
            size='medium'
            onClick={() => {
              TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                page: TRACKING.PAGES.SETTINGS,
                page_tab: TRACKING.PAGE_TABS.TEAM_SLACK,
                click_type: TRACKING.CLICK.EDIT_NOTIFICATIONS_SETTINGS
              });

              history.push({
                pathname: AppRouter.NOTIFICATIONS.path
              });
            }}
          >
            Edit Notification Settings
          </HyperLink>
        </Tooltip>
      </Flex>
    </Flex>
  </>
);

export default TeamNotificationListHeaders;
